import { PlayerTournamentCard } from '@/modules/players/v2/tabs/components/PlayerTournamentCard';
import { PlayerData } from '@/types/players.types';
import { PlayerTournamentsData } from '@/types/playerTournaments.types';

interface NextSignedUpTourneyProps {
  data: PlayerTournamentsData[];
  player: PlayerData | undefined;
}

export function NextSignedUpTourney({ data, player }: NextSignedUpTourneyProps) {
  return data && data.length > 0 ? (
    <div className='mb-10 mt-6 grid grid-cols-1 min-[500px]:grid-cols-2 gap-4 py-4 md:gap-10 md:grid-cols-3 lg:grid-cols-4'>
      {data.map((tourney) => {
        return <PlayerTournamentCard key={tourney.tournamentUuid} tourney={tourney} />;
      })}
    </div>
  ) : (
    <div className='mb-10 mt-6 flex w-full justify-center rounded-lg border bg-white shadow-md sm:w-1/2'>
      <div className='p-8 text-gray-900'>
        {player?.firstName} {player?.lastNameAndSuffix} is not registered for any upcoming
        tournaments.
      </div>
    </div>
  );
}
